export const DEAL_INSIGHTS_COLUMN_MIN_WIDTH = {
  METRIC: '120px',
  DEAL_NAME: '280px',
  DOMAIN_BUNDLE: '200px',
  APP_NAME: '180px',
  AD_SIZE: '280px',
  AD_DURATION: '140px',
  GEOLOCATION: '200px',
} as const;
